export const getInitials = (name: string) => {
    return name && name.length > 0 ? name.trim().substring(0, 1).toUpperCase() : '';
};

export const getFontSize = (size: number) => {
    return Math.min(size / 2.2, 32);
};
